const FooterColumnTypeENUM = Object.freeze({
    Text: 0, 
    Logo: 1, 
});

export default FooterColumnTypeENUM;
